module.exports = __webpack_public_path__ + "static/img/l4.0351a5e8.png";